import { FC } from "react";
import SettingTitle from "../component/SettingTitle";
import { Box } from "@mui/material";
import { RequireAuth } from "@/components/RequireAuth";
import { books } from "@/assets/books";
import MenuItemCard from "../component/MenuItemCard";
import NotificationSettingsSvg from "@/assets/svg/NotificationSettings";
import { Outlet, useLocation } from "react-router-dom";

interface INotificationProps {}

const Notifications: FC<INotificationProps> = ({}) => {
  const location = useLocation();
  const isRootSettings = location.pathname === "/settings/notifications";
  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        width: "100%",
      }}
    >
      {isRootSettings ? (
        <Box>
          <SettingTitle title="Notifications" isActive={true} />
          <Box bgcolor="white">
            <RequireAuth>
              <MenuItemCard
                item={{
                  title: "Manage Notifications",
                  subtitle:
                    "Select the kinds of notifications you get about your activities, interests, and recommendations.",
                  icon: <NotificationSettingsSvg />,
                  link: books.manageNotifications,
                }}
              />
            </RequireAuth>
          </Box>
        </Box>
      ) : (
        <Box sx={{ maxWidth: "544px", width: "100%" }}>
          <Outlet />
        </Box>
      )}
    </Box>
  );
};

export default Notifications;
